import InfoIcon from "@mui/icons-material/Info";
import { Box, Stack, Typography } from "@mui/material";

const NoImpactField = ({ columnLabel }: any) => {
  return (
    <>
      <Box
        sx={{
          border: "1px solid #0288D180",
          borderRadius: "8px",
          backgroundColor: "#0288D10A",
          p: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <InfoIcon
            sx={{
              color: "#01579B",
              fontSize: 18,
            }}
          />

          <Typography
            sx={{
              color: "#01579B",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            No impact on this field
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: "#01579B",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          Fraud users were detected for this brand, but this specific field
          <strong> ({columnLabel})</strong> had a subtracted value of{" "}
          <strong>0</strong>. Other fields may have been impacted.
        </Typography>
      </Box>
    </>
  );
};

export default NoImpactField;
